import SuperFetch from '../../../superFetch.js';

class CsInquiryApi {
  /**
   *  [1:1 문의 리스트] 1:1 문의 리스트 요청하기
   */
  getCsInquiryList = (data) => SuperFetch.post('/cs/inquiry/list', data);

  /**
   *  [1:1 문의 상세] 1:1 문의 리스트 excel 다운로드 요청하기
   */
  getInquiryExcelDownload = (data) => SuperFetch.post('/cs/inquiry/list/excel/download', data);

  /**
   *  [1:1 문의 상세] 1:1 문의 상세 요청하기
   */
  getCsInquiryDetail = (data) => SuperFetch.post('/cs/inquiry/detail', data);

  /**
   *  [1:1 문의 상세] 이전 문의 내역 조회하기
   */
  getCsUsersOtherInquiryList = (data) => SuperFetch.post('/cs/inquiry/detail/users/other/list', data);

  /**
   *  [1:1 문의 상세] 1:1 문의 답변 작성하기
   */
  replyCsInquiryDetail = (data) => SuperFetch.post('/cs/inquiry/detail/reply', data);
}

export default new CsInquiryApi();
